'use client';

import { m } from 'motion/react';
import { SocialLinks } from '../social-links/social-links';

export const StickyBox = () => (
  <m.div
    initial={{ opacity: 0, rotate: '-90deg', top: '50%', right: '-2.5rem', translateY: '-150%' }}
    animate={{ opacity: 1, rotate: '-90deg', top: '50%', right: '0', translateY: '-150%'}}
    transition={{ delay: 0.2 }}
    whileHover={{ translateX: '-2.3rem' }}
    className="fixed z-20 bg-action text-background px-6 py-1 rounded-t-md origin-right shadow-lg"
  >
    <p className="text-background text-center mb-2">Sprawdź nas na:</p>
    <SocialLinks rotateIcons />
  </m.div>
);
